import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";

function ReadOnlyPPRatesRow({
  ppr,
  selectedNode,
  handleEditClick,
  handleDeleteClick,
}) {
  return (
    <Table spacing="small">
      <TableRow>
        <TableCell width={100}>
          <Input value={selectedNode} />
        </TableCell>
        <TableCell width={200}>
          <Input value={ppr.process_path} />
        </TableCell>
        <TableCell width={150}>
          <Input value={ppr.size} />
        </TableCell>
        <TableCell width={150}>
          <Input value={ppr.role} />
        </TableCell>
        <TableCell width={100}>
          <Input value={ppr.rate} />
        </TableCell>
        <TableCell>
          <Row>
            <Button minWidth={70} onClick={(event) => handleDeleteClick(ppr)}>
              Delete
            </Button>
            <Button minWidth={70} onClick={(event) => handleEditClick(ppr)}>
              Edit
            </Button>
          </Row>
        </TableCell>
      </TableRow>
    </Table>
  );
}

export default ReadOnlyPPRatesRow;
